var map = {
	"./404-clouds-2.png": "8e20",
	"./404-clouds.png": "7f57",
	"./Caret.svg": "9f3e",
	"./Ironshore_W.png": "7327",
	"./Mask-Watercolor-sign-up.png": "060e",
	"./bannerBg.png": "e465",
	"./bottom-banner-cloud.png": "05de",
	"./boy-homework-sm.png": "f1a9",
	"./boy-homework.png": "0d39",
	"./card/arrows.png": "10d7",
	"./card/capsule.png": "2362",
	"./card/clock.png": "36a0",
	"./card/crops.png": "76f3",
	"./card/dosing.png": "a174",
	"./card/jpm_clock-icon.png": "4aa9",
	"./card/jpm_clock-icon@2x.png": "3387",
	"./card/jpm_moon-icon.png": "e79a",
	"./card/jpm_moon-icon@2x.png": "6405",
	"./card/list.png": "4e2c",
	"./card/moon.png": "3fda",
	"./card/pig.png": "9eae",
	"./card/question.png": "bb07",
	"./card/sun.png": "be86",
	"./card/sunrise.png": "3337",
	"./clouds-bg-2v.png": "818e",
	"./clouds-bg-m.png": "a484",
	"./clouds-bg.png": "a9cf",
	"./cookie-component/closeBtn.svg": "84b9",
	"./different-delivery/delayed-dosing-sm.png": "bb58",
	"./different-delivery/delayed-dosing.png": "cd4b",
	"./different-delivery/line_delayed.png": "610d",
	"./different-delivery/line_drug.png": "3c05",
	"./different-delivery/line_extended.png": "b7db",
	"./different-delivery/man-presenting-sm.png": "765a",
	"./different-delivery/man-presenting.png": "e7fc",
	"./different-delivery/midday-bg.png": "02b6",
	"./different-delivery/morning-background.png": "b7e7",
	"./different-delivery/pk_curve.png": "958e",
	"./different-delivery/pk_curve_sm.png": "3ee2",
	"./dosing/1.png": "02da",
	"./dosing/1A12C3820DA9CBD5.png": "94c9",
	"./dosing/1A12C3820DA9CBD6.png": "b9d3",
	"./dosing/3.png": "3f1c",
	"./dosing/4.png": "21a6",
	"./dosing/5.png": "3318",
	"./dosing/6.png": "75e8",
	"./dosing/75.svg": "5139",
	"./dosing/Mask-Banner.png": "ce50",
	"./dosing/amann.png": "dd3a",
	"./dosing/boy-dosing-sm.png": "f82f",
	"./dosing/boy-dosing.png": "2625",
	"./dosing/capsules-mobile.png": "d5c8",
	"./dosing/capsules.png": "eb01",
	"./dosing/checkmark.svg": "2ae8",
	"./dosing/cta-dosing-bg-1.png": "4592",
	"./dosing/cta-dosing-bg-mobile.png": "413e",
	"./dosing/cta-dosing-bg.png": "fb33",
	"./dosing/ddd-ruler.png": "705e",
	"./dosing/dose-graph-mobile-noicon.png": "7f06",
	"./dosing/dose-graph-mobile.png": "71fe",
	"./dosing/dose-graph.png": "07e2",
	"./dosing/dosing-icon.png": "fc08",
	"./dosing/jim-anderson.png": "20e2",
	"./dosing/night-bg-sm.png": "daf8",
	"./dosing/night-bg.png": "e298",
	"./dosing/pills-dosing.png": "f50a",
	"./dosing/pills.svg": "ccf3",
	"./dosing/quote-bottom.svg": "9243",
	"./dosing/quote-top.svg": "22c9",
	"./dosing/top-banner-image-m.png": "061b",
	"./dosing/top-banner-image.png": "a8ac",
	"./efficacy/Caret-Right-2.svg": "2766",
	"./efficacy/Caret-Right.svg": "bb98",
	"./efficacy/Graph1.png": "a945",
	"./efficacy/Graph2.png": "b6b1",
	"./efficacy/Graph3.png": "4951",
	"./efficacy/JORNAY_Vector_Charts-2-mobile-noicon.png": "f3d1",
	"./efficacy/JORNAY_Vector_Charts-2-mobile.png": "f5f7",
	"./efficacy/JORNAY_Vector_Charts-2.png": "d8aa",
	"./efficacy/afternoon-results-1.png": "0faa",
	"./efficacy/afternoon-results-2.png": "6690",
	"./efficacy/afternoon_study1.png": "f8c6",
	"./efficacy/afternoon_study1_sm.png": "3431",
	"./efficacy/afternoon_study2.png": "1b3d",
	"./efficacy/afternoon_study2_sm.png": "9fc7",
	"./efficacy/box-clouds-2.png": "7924",
	"./efficacy/box-clouds-3.png": "2014",
	"./efficacy/box-clouds-4.png": "0c56",
	"./efficacy/box-clouds.png": "d062",
	"./efficacy/bsfq-mobile-1.svg": "a22f",
	"./efficacy/bsfq-mobile-2.svg": "f3d3",
	"./efficacy/bsfq.svg": "791e",
	"./efficacy/daytime-results-1.png": "a371",
	"./efficacy/daytime-results-2.png": "5e2f",
	"./efficacy/daytime_study1.png": "4c22",
	"./efficacy/daytime_study1_sm.png": "89c5",
	"./efficacy/daytime_study2.png": "9894",
	"./efficacy/daytime_study2_sm.png": "58eb",
	"./efficacy/document.png": "a9d5",
	"./efficacy/efficacy-table.svg": "5369",
	"./efficacy/hold.png": "d20a",
	"./efficacy/icon-evening-2.png": "b652",
	"./efficacy/icon-evening.png": "62af",
	"./efficacy/icon-morning-2.png": "49f4",
	"./efficacy/icon-morning.png": "53ae",
	"./efficacy/midday-background-sm.png": "09b1",
	"./efficacy/midday-background.png": "ad8a",
	"./efficacy/morning-background.png": "06d1",
	"./efficacy/morning_study1.png": "79f3",
	"./efficacy/morning_study1_sm.png": "a467",
	"./efficacy/morning_study2.png": "743e",
	"./efficacy/morning_study2_sm.png": "f1e6",
	"./efficacy/premb-r-pm-mobile-1.svg": "a3ea",
	"./efficacy/premb-r-pm-mobile-2.svg": "089f",
	"./efficacy/premb-r-pm.svg": "d36f",
	"./efficacy/study-design.png": "0aa6",
	"./efficacy/tap.svg": "8279",
	"./evening-bg.png": "ece0",
	"./footer/Collegium_White.png": "36f8",
	"./footer/Collegium_White.svg": "42d3",
	"./footer/ironshore-logo.svg": "7953",
	"./footer/ironshore_logo-white.png": "5208",
	"./footer/ironshore_logo-white_mobile.png": "75ae",
	"./head/HeadlineBanner.jpg": "76f7",
	"./head/JPM_Gradient_03.jpg": "1740",
	"./header/header-bg.png": "1ec3",
	"./header/header-bg_s.png": "d713",
	"./header/jornay-logo.png": "537a",
	"./header/jornay-logo.svg": "280d",
	"./header/logo-header.svg": "82d4",
	"./header/nav-bg-md.png": "fc4b",
	"./header/nav-bg-sm.png": "3418",
	"./home/andrew-cutler-headshot.png": "8991",
	"./home/art-kids-m.png": "e213",
	"./home/art-kids.png": "7df2",
	"./home/bg.png": "2de1",
	"./home/body-bg.png": "be1e",
	"./home/boy-waking-sm.png": "0e92",
	"./home/boy-waking.png": "9a31",
	"./home/caret-right.svg": "1bfa",
	"./home/chaos_section_bg.png": "a579",
	"./home/chaos_section_bg_sm.png": "6149",
	"./home/checkbox.svg": "c8b9",
	"./home/cta-bg-mobile.png": "8cbc",
	"./home/cta-bg.png": "5eb3",
	"./home/cta-home-bg-mobile.png": "13ae",
	"./home/cta-home-bg.png": "19dc",
	"./home/four-times.png": "94cc",
	"./home/hero-tape-measure.png": "0906",
	"./home/hero_boy_chaos.png": "87a2",
	"./home/hero_boy_chaos_sm.png": "f003",
	"./home/icon-1.png": "c1dc",
	"./home/icon-2.png": "5910",
	"./home/icon-3.png": "2381",
	"./home/icon-4.png": "0865",
	"./home/patient-profile-adult.png": "2fbb",
	"./home/patient-profile-school.png": "d732",
	"./home/rect.png": "c34a",
	"./home/seventy-percent.png": "d79a",
	"./icon-Link.svg": "c02e",
	"./input/oval.svg": "b463",
	"./input/oval_selected.svg": "1b55",
	"./input/rectangle.svg": "173b",
	"./input/rectangle_selected.svg": "d4fe",
	"./kids.png": "8f81",
	"./main-background.png": "389c",
	"./main-bg.png": "7d4a",
	"./mic-icon.svg": "ca20",
	"./moa-tmb.png": "bb88",
	"./modal/close.svg": "6259",
	"./modal/desktop-shortage-modal-img.png": "350a",
	"./modal/ironshore-logo.png": "a248",
	"./modal/mobile-shortage-modal-img.png": "c2b9",
	"./modal/mobile-shortage-modal-img.svg": "7daf",
	"./modal/shortage-modal-bg.png": "55e8",
	"./new-home/arrow.png": "676c",
	"./new-home/card-n.png": "4e8d",
	"./new-home/card.png": "3664",
	"./new-home/choose01.png": "8a5b",
	"./new-home/choose02.png": "fa2c",
	"./new-home/closeIsiBtn.svg": "49cc",
	"./new-home/dosing-pills.png": "3e33",
	"./new-home/dosing-pills.svg": "db7a",
	"./new-home/graph-01.png": "8e81",
	"./new-home/graph-02.png": "b7c6",
	"./new-home/graph-1-chart.png": "e0cc",
	"./new-home/graph-2-chart.png": "5629",
	"./new-home/heroimage.png": "50cf",
	"./new-home/heroimg.png": "ff12",
	"./new-home/jornay-logo-mobile.svg": "cd81",
	"./new-home/jornay-logo.svg": "d055",
	"./new-home/jornay-mobile-logo.svg": "0c39",
	"./new-home/jpm_icons1.png": "8048",
	"./new-home/jpm_icons1.svg": "c935",
	"./new-home/jpm_icons2.png": "283a",
	"./new-home/jpm_icons2.svg": "75f2",
	"./new-home/jpm_icons3.png": "f5d1",
	"./new-home/jpm_icons3.svg": "44a5",
	"./new-home/jpm_icons4.png": "a2d0",
	"./new-home/jpm_icons4.svg": "d35e",
	"./new-home/menu-arrow.png": "335c",
	"./new-home/optimizing-dosing.png": "f0e3",
	"./new-home/optimizing-dosing.svg": "cdbb",
	"./new-home/safety-check.png": "009a",
	"./new-home/thick.png": "5ec4",
	"./new-home/why1.png": "3a71",
	"./new-home/why1.svg": "74ec",
	"./new-home/why2.png": "e396",
	"./new-home/why2.svg": "ef19",
	"./new-home/why3.png": "0ee6",
	"./new-home/why3.svg": "48ea",
	"./peer-videos/charlie-tmb.png": "0b01",
	"./peer-videos/video-connectivy-1.png": "23f7",
	"./peer-videos/video-connectivy-2.png": "87b9",
	"./peer-videos/video-connectivy-3.png": "a482",
	"./peer-videos/video-connectivy-4.png": "ebe5",
	"./peer-videos/video-simply-1.png": "98d3",
	"./peer-videos/video-simply-2.png": "4714",
	"./peer-videos/video-simply-3.png": "82bf",
	"./peerspectives/andrew-cutler.png": "3891",
	"./peerspectives/birgit-amann.png": "8c73",
	"./peerspectives/cloud-bg.png": "4e92",
	"./peerspectives/coming-soon.png": "0aad",
	"./peerspectives/expert-1.png": "45f5",
	"./peerspectives/expert-2.png": "68f5",
	"./peerspectives/expert-3.png": "3bb6",
	"./peerspectives/expert-4.png": "450b",
	"./peerspectives/expert-bg.png": "e85d",
	"./peerspectives/jim-anderson.png": "cb4a",
	"./peerspectives/maitri-patel.png": "46cb",
	"./peerspectives/peerspectives-bg-m.png": "c96f",
	"./peerspectives/peerspectives-bg.png": "dc4c",
	"./peerspectives/video-1-tmb.png": "ce48",
	"./peerspectives/video-2-tmb.png": "6054",
	"./peerspectives/video-3-tmb.png": "bb8b",
	"./peerspectives/video-4-tmb.png": "0593",
	"./pk-bg.png": "6a87",
	"./play-btn.svg": "e29a",
	"./pricing-information-clouds-2.png": "0880",
	"./pricing-information-clouds.png": "7f00",
	"./request-info/class-group-sm.png": "7a3f",
	"./request-info/class-group.png": "3319",
	"./request-info/jornaypm_adhd_pediatric_band.svg": "0006",
	"./request-info/midday-bg.png": "88d4",
	"./resources/adult-discussion.png": "f7b4",
	"./resources/body-bg-m.png": "fb1f",
	"./resources/body-bg.png": "5f2a",
	"./resources/content-savings-cloud-m.png": "9c34",
	"./resources/copay-savings.png": "4e9e",
	"./resources/dosing-guide.png": "d0ba",
	"./resources/pharmacy-instructions.png": "df83",
	"./resources/res01.png": "6dba",
	"./resources/res02.png": "7449",
	"./resources/res03.png": "d7d4",
	"./resources/res04.png": "f76b",
	"./resources/res05.png": "9340",
	"./resources/res06.png": "281f",
	"./resources/res07.png": "bbab",
	"./resources/res1-m.png": "013b",
	"./resources/res1.png": "09da",
	"./resources/res2-m.png": "1921",
	"./resources/res2.png": "e51b",
	"./resources/res3-m.png": "d24a",
	"./resources/res3.png": "c0cf",
	"./resources/res4-m.png": "072f",
	"./resources/res4.png": "4930",
	"./resources/resource01.png": "5a2d",
	"./resources/resource02.png": "187d",
	"./resources/resource03.png": "0c17",
	"./resources/resource04.png": "5816",
	"./resources/resource05.png": "1568",
	"./resources/resource06.png": "8891",
	"./resources/resource07.png": "fcdc",
	"./resources/resource08.png": "cc84",
	"./resources/resource09.png": "aacf",
	"./resources/savings-cloud-m.png": "8dda",
	"./resources/school-aged-discussion.png": "7e79",
	"./ruler-line-break.png": "a38d",
	"./safety/Mask-Watercolor-2.png": "23a8",
	"./safety/Mask-Watercolor.png": "c1dd",
	"./safety/Mask-WatercolorTop-2.png": "a03a",
	"./safety/Mask-WatercolorTop.png": "87e1",
	"./safety/girl-violin.png": "af9d",
	"./safety/morning-background.png": "7b95",
	"./safety/safety-bg-m.png": "2881",
	"./safety/safety-bg.png": "fc29",
	"./safety/safety-icon-1.png": "3a58",
	"./safety/safety-icon-2.png": "703e",
	"./safety/woman-waking.png": "146f",
	"./savings/cta-bg.png": "a5de",
	"./savings/savings-body-bg.png": "ec4a",
	"./savings/savings-cloud-m-2.png": "7044",
	"./savings/savings-cloud-m.png": "3adf",
	"./savings/savings-cloud.png": "646e",
	"./savings/savings-mobile.png": "ffa2",
	"./savings/savings-mobile.svg": "568f",
	"./savings/savings.png": "02d0",
	"./sitemap-clouds-2.png": "2542",
	"./sitemap-clouds.png": "2888",
	"./smooth-pk/bg-smooth-mobile.png": "1d8c",
	"./smooth-pk/bg-smooth.png": "5de6",
	"./smooth-pk/lightblue-bg.png": "879f",
	"./smooth-pk/smooth-pk-chart-mobile-noicon.png": "734b",
	"./smooth-pk/smooth-pk-chart-mobile.png": "9266",
	"./smooth-pk/smooth-pk-chart.png": "8985",
	"./smooth-pk/smooth-video.png": "3861",
	"./stars_inset.png": "b2a5",
	"./storm_clouds.png": "c767",
	"./support/PNMT_Card.svg": "eccc",
	"./support/card.png": "8534",
	"./support/card.svg": "a2f2",
	"./support/location-pin.png": "8bc0",
	"./support/woman-evening.png": "ed71",
	"./thank-you/bg.png": "4b54",
	"./thank-you/reading-guy.png": "fd61",
	"./thank-you/reading-guy@2x.png": "4783",
	"./top.svg": "db5d",
	"./videos/bg.png": "a437",
	"./videos/webinar2.jpg": "d919",
	"./woman-organized.png": "5fe8",
	"./yellow-btn-hover.png": "284f",
	"./yellow-btn.png": "cbe6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";